<template>
	<div class="wrap" :class="{ 'wrap--public': isPublicRoute }">
		<UpdateBanner />
		<HeaderComponent v-if="checkRoute()" />
		<router-view />
	</div>
</template>
<script>
import HeaderComponent from '@/components/HeaderComponent.vue';
import UpdateBanner from '@/components/UpdateBanner.vue';
export default {
	name: 'App',
	components: {
		HeaderComponent,
		UpdateBanner,
	},
	computed: {
		currentRouteName() {
			return this.$route.name;
		},
		/**
		 * 고객이 로그인 없이 여는 화면인가.
		 * .wrap 은 사내 화면 기준으로 min-width:1400px 이 걸려 있어(common.scss) 그대로 두면
		 * 고객 리포트가 휴대폰에서 가로로 스크롤된다(실측: 390px 화면에서 1400px). 카톡으로
		 * 링크를 받아 폰에서 보는 것이 기본 사용 환경이라 이 화면만 그 제약에서 뺀다.
		 */
		isPublicRoute() {
			return this.currentRouteName === 'PublicReport';
		},
	},
	data() {
		return {};
	},
	created() {},
	methods: {
		checkRoute() {
			// 로그인 전에는 사내 헤더를 그리지 않는다. 라우터가 첫 경로를 해석하기 전에는
			// currentRouteName 이 비어 있어 아래 화면 목록이 아직 걸리지 않는데, 그 사이에 헤더가
			// 잠깐 뜨면 고객용 공개 리포트에 회사 메뉴가 스쳐 보인다.
			if (!this.$store.getters.getToken) return false;
			if (
				this.currentRouteName == 'LoginView' ||
				this.currentRouteName == 'UserDetail' ||
				this.currentRouteName == 'MapDetail' ||
				this.currentRouteName == 'MapWrite' ||
				this.currentRouteName == 'PrintPage' ||
				this.currentRouteName == 'PrintPage2' ||
				this.currentRouteName == 'RentPrintPage' ||
				this.currentRouteName == 'RentPrintPage2' ||
				this.currentRouteName == 'LeaseMapDetail' ||
				this.currentRouteName == 'LeaseMapWrite' ||
				this.currentRouteName == 'LeaseUserDetail' ||
				this.currentRouteName == 'LeaseUserAdmin2' ||
				this.currentRouteName == 'MapSearch2' ||
				this.currentRouteName == 'LeaseMapSearch2' ||
				this.currentRouteName == 'UserAdmin2' ||
				this.currentRouteName == 'ScrapingDetail' ||
				this.currentRouteName == 'ScrapingDetail2' ||
				// CM: 고객이 카톡 링크로 여는 화면. 로그인하지 않은 외부인이 보므로 사내 헤더를 띄우지 않는다.
				this.currentRouteName == 'PublicReport'
			) {
				return false;
			} else {
				return true;
			}
		},
	},
};
</script>

<style>
/* 고객 공개 화면 전용 — 사내 데스크톱 전제(min-width:1400px, 회색 배경)를 걷어낸다.
   scoped 가 아니어야 부모 .wrap 에 닿는다. */
.wrap.wrap--public {
	min-width: 0;
	background: #fff;
	overflow-x: hidden;
}
</style>
